import { Button } from '@mui/material';
import { ReactNode } from 'react';
import { LIGHT_BLACK } from 'utils/theme';

interface FooterButtonProps {
  children: ReactNode;
  onClick: () => void;
  background?: string;
  border?: string;
}

const FooterButton = ({
  children,
  onClick,
  background = 'white',
  border = 'none',
}: FooterButtonProps) => {
  return (
    <Button
      onClick={onClick}
      sx={{
        background,
        border,
        color: LIGHT_BLACK,
        borderRadius: '20px',
        textTransform: 'none',
        px: 2,
      }}
    >
      {children}
    </Button>
  );
};

export default FooterButton;
